import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import Cookies from 'js-cookie';

export const GetFileArchiveListForView = async (
  GetFileArchiveList
) => {
  const user = JSON.parse(Cookies.get('user'));

  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_FILE_ARCHIVE_FOR_VIEW}`,
    true,
    {
      idPatient: user?.IdPatient,
      idConfer: 0,
      idType: 0,
      NameType: 'اطلاعات فردی',
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      let arrayCopy = [
        ...response.data.Data.ListFileArchive,
      ];
      arrayCopy.sort((a, b) => b.Id - a.Id);

      GetFileArchiveList(arrayCopy);
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
